import {useState, useEffect} from 'react'
import {v4 as uuidv4} from 'uuid'
import CommentItem from '../CommentItem'
import './index.css'

const initialContainerBackgroundClassNames = [
  'amber',
  'blue',
  'orange',
  'emerald',
  'teal',
  'red',
  'light-blue',
]

const Comments = () => {
  const commentsData = JSON.parse(localStorage.getItem('List'))

  const [nameInput, setNameInput] = useState('')
  const [textInput, setTextInput] = useState('')
  const [commentList, setCommentList] = useState(
    commentsData !== null ? commentsData : [],
  )

  const nameValue = event => {
    setNameInput(event.target.value)
  }

  const textAreaValue = event => {
    setTextInput(event.target.value)
  }

  const onSubmitButton = event => {
    event.preventDefault()
    const initialColorClassName = `initial-container ${
      initialContainerBackgroundClassNames[
        Math.ceil(
          Math.random() * initialContainerBackgroundClassNames.length - 1,
        )
      ]
    }`

    console.log(initialColorClassName)

    const newComment = {
      id: uuidv4(),
      name: nameInput,
      comment: textInput,
      date: new Date().toISOString(),
      className: initialColorClassName,
      isLiked: false,
    }

    setCommentList(prevComment => [...prevComment, newComment])
    setNameInput('')
    setTextInput('')
  }

  useEffect(() => {
    localStorage.setItem('List', JSON.stringify(commentList))
  })

  const onDelete = id => {
    const filterData = commentList.filter(eachComment => eachComment.id !== id)
    setCommentList(filterData)
  }

  const onLikeButton = id => {
    setCommentList(prevComment =>
      prevComment.map(eachComment => {
        if (eachComment.id === id) {
          return {...eachComment, isLiked: !eachComment.isLiked}
        }
        return eachComment
      }),
    )
  }

  return (
    <div className="bg-container">
      <h1 className="head-1">Comments</h1>
      <div className="form-img-container">
        <form className="form-container" onSubmit={onSubmitButton}>
          <h1 className="head">Comments</h1>

          <p className="para">say Something about 4.0 Technologies</p>

          <input
            type="text"
            placeholder="Your Name"
            className="name-input"
            required
            size={27}
            minLength={4}
            maxLength={25}
            onChange={nameValue}
            value={nameInput}
          />
          <br />
          <textarea
            placeholder="Your Comment"
            className="text-input"
            rows={8}
            cols={30}
            required
            onChange={textAreaValue}
            value={textInput}
          />
          <br />
          <button type="submit" className="button">
            Add Comment
          </button>
        </form>
        <img
          src="https://assets.ccbp.in/frontend/react-js/comments-app/comments-img.png"
          alt="comments"
          className="img"
        />
      </div>
      <hr className="hr-line" />
      <div className="length-container">
        <p className="comments-length">{commentList.length}</p>
        <p className="comments-length-head">Comments</p>
      </div>
      <ul className="list-main-container">
        {commentList.map(eachComment => (
          <CommentItem
            key={eachComment.id}
            commentDetails={eachComment}
            onDelete={onDelete}
            onLikeButton={onLikeButton}
          />
        ))}
      </ul>
    </div>
  )
}

export default Comments
